import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitter, FaLinkedinIn, FaInstagram, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const footerLinks = {
  Product: [
    { label: 'Features', path: '/features' },
    { label: 'Pricing', path: '/pricing' },
    { label: 'How It Works', path: '/how-it-works' },
    { label: '3D Design Studio', path: '/features#design-studio' },
    { label: 'Cost Estimator', path: '/features#cost-engine' },
  ],
  Company: [
    { label: 'About Us', path: '/about' },
    { label: 'Blog', path: '/blog' },
    { label: 'Careers', path: '/about#careers' },
    { label: 'For Partners', path: '/partners' },
  ],
  Support: [
    { label: 'Contact Us', path: '/contact' },
    { label: 'FAQ', path: '/faq' },
    { label: 'WhatsApp', path: 'https://wa.me/919876543210', external: true },
  ],
  Legal: [
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms of Service', path: '/terms' },
  ],
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__glow" />
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
                <defs>
                  <linearGradient id="footerLogoGrad" x1="4" y1="4" x2="36" y2="34" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor="#2CB67D" />
                    <stop offset="100%" stopColor="#4ECDC4" />
                  </linearGradient>
                </defs>
                <path d="M20 4L4 18H10V34H30V18H36L20 4Z" fill="url(#footerLogoGrad)" />
                <path d="M16 24H24V34H16V24Z" fill="rgba(255,255,255,0.9)" />
              </svg>
              <span>Sculpit</span>
            </Link>
            <p className="footer__tagline">
              India's first AI-powered construction platform. Design, plan, and build your dream home - all in one place.
            </p>
            <div className="footer__social">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
            </div>
          </div>

          <div className="footer__links-grid">
            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category} className="footer__column">
                <h4 className="footer__column-title">{category}</h4>
                <ul>
                  {links.map((link) => (
                    <li key={link.label}>
                      {link.external ? (
                        <a href={link.path} target="_blank" rel="noopener noreferrer">{link.label}</a>
                      ) : (
                        <Link to={link.path}>{link.label}</Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Sculpit Innovations Private Limited, Bengaluru, India. All rights reserved.</p>
          <p className="footer__reg">CIN: U43900KA2026PTC217041</p>
        </div>
      </div>
    </footer>
  );
}
